import { render, staticRenderFns } from "./DepartamentoList.vue?vue&type=template&id=3251e6ca&scoped=true&"
import script from "./DepartamentoList.vue?vue&type=script&lang=js&"
export * from "./DepartamentoList.vue?vue&type=script&lang=js&"
import style0 from "./DepartamentoList.vue?vue&type=style&index=0&id=3251e6ca&lang=scss&scoped=true&"
import style1 from "./DepartamentoList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3251e6ca",
  null
  
)

export default component.exports